/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class FeatureTogglesConstants {
}
FeatureTogglesConstants.GLOBAL_KEY = 'window.sirius.shared.featureToggles';
FeatureTogglesConstants.DEFAULT_NAMESPACE = 'platform';
FeatureTogglesConstants.DEFAULT_NAMESPACE_SEPARATOR = '::';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZS10b2dnbGVzLmNvbnN0YW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zaGFyZWQvZmVhdHVyZS10b2dnbGVzL2ZlYXR1cmUtdG9nZ2xlcy5jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sdUJBQXVCOztBQUNULGtDQUFVLEdBQUcscUNBQXFDLENBQUM7QUFFbkQseUNBQWlCLEdBQUcsVUFBVSxDQUFDO0FBQy9CLG1EQUEyQixHQUFHLElBQUksQ0FBQyJ9